export enum FloatingButtonActionType {
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
}

export interface IFloatingButtonConfig {
  id?: string;
  label: string;
  altLabel?: string;
  type: FloatingButtonActionType;
  value: string; // Message text or URL
  action?: () => void;
  buttonStyle?: 'primary' | 'secondary' | 'tertiary';
  allowedUrls?: string[];
  excludedUrls?: string[];
}
